import { BadgeCheck, Crown, Gem, Sparkles } from "lucide-react";

const D = {
  aetryx_original: { label: "AETRYX ORIGINAL", Icon: Crown, cls: "text-[#FFD86A] border-[#FFD86A]/50" },
  aetryx_exclusive: { label: "AETRYX EXCLUSIVE", Icon: Gem, cls: "text-[#7CF7FF] border-[#00F0FF]/40" },
  creator_original: { label: "CREATOR ORIGINAL", Icon: Sparkles, cls: "text-[#F5C451] border-[#F5C451]/40" },
};
export const DESIGNATION_LABEL = Object.fromEntries(Object.entries(D).map(([k, v]) => [k, v.label]));

export const DesignationBadge = ({ value, size = "sm", testId }) => {
  const d = D[value];
  if (!d) return null;
  const big = size === "lg";
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-full border bg-[#050505]/75 font-bold backdrop-blur ${d.cls} ${big ? "px-3 py-1 text-xs tracking-[0.22em]" : "px-1.5 py-0.5 text-[0.5rem] tracking-[0.14em]"}`}>
      <d.Icon className={big ? "h-3.5 w-3.5" : "h-2.5 w-2.5"} /> {big ? d.label : d.label.replace("AETRYX ", "")}
    </span>
  );
};

export const VerifiedCheck = ({ className = "h-4 w-4", testId }) => (
  <BadgeCheck data-testid={testId} aria-label="Verified creator" className={`flex-none fill-[#D4AF37] text-[#050505] ${className}`} />
);
